import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantTerminalService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type params = {
	terminalId: string;
	merchantId: string;
};

const useCopyTerminalSolutionByMerchantMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ terminalId, merchantId }: params) =>
			merchantTerminalService.copyTerminalSolution(
				terminalId,
				merchantId,
			),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useCopyTerminalSolutionByMerchantMutation;
